package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Topaz: ImageVector
    get() {
        if (_Topaz != null) {
            return _Topaz!!
        }
        _Topaz = ImageVector.Builder(
            name = "Topaz",
            defaultWidth = 39.795.dp,
            defaultHeight = 37.848.dp,
            viewportWidth = 39.795f,
            viewportHeight = 37.848f
        ).apply {
            path(
                fill = SolidColor(Color(0xFFFF8000)),
                fillAlpha = 0.8f
            ) {
                moveTo(29.788f, 26.11f)
                lineToRelative(-6.112f, 4.441f)
                lineToRelative(-7.555f, 0f)
                lineToRelative(-6.113f, -4.441f)
                lineToRelative(-2.335f, -7.186f)
                lineToRelative(2.335f, -7.186f)
                lineToRelative(6.113f, -4.441f)
                lineToRelative(7.555f, 0f)
                lineToRelative(6.112f, 4.441f)
                lineToRelative(2.335f, 7.186f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD46A01)),
                fillAlpha = 0.8f
            ) {
                moveTo(29.093f, 25.605f)
                lineToRelative(-5.683f, 4.129f)
                lineToRelative(-7.024f, 0f)
                lineToRelative(-5.683f, -4.129f)
                lineToRelative(-2.171f, -6.68f)
                lineToRelative(2.171f, -6.681f)
                lineToRelative(5.683f, -4.129f)
                lineToRelative(7.024f, 0f)
                lineToRelative(5.683f, 4.129f)
                lineToRelative(2.171f, 6.681f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF972E)),
                fillAlpha = 0.8f
            ) {
                moveTo(28.361f, 25.073f)
                lineToRelative(-5.231f, 3.8f)
                lineToRelative(-6.465f, 0f)
                lineToRelative(-5.231f, -3.8f)
                lineToRelative(-1.998f, -6.149f)
                lineToRelative(1.998f, -6.149f)
                lineToRelative(5.231f, -3.8f)
                lineToRelative(6.465f, 0f)
                lineToRelative(5.231f, 3.8f)
                lineToRelative(1.998f, 6.149f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD46A01)),
                fillAlpha = 0.8f
            ) {
                moveTo(13.749f, 37.848f)
                lineToRelative(2.371f, -7.297f)
                lineToRelative(7.555f, 0f)
                lineToRelative(2.371f, 7.297f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF8000)),
                fillAlpha = 0.8f
            ) {
                moveTo(16.12f, 30.55f)
                lineToRelative(-6.113f, -4.441f)
                lineToRelative(-5.92f, 4.719f)
                lineToRelative(9.661f, 7.019f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF972E)),
                fillAlpha = 0.8f
            ) {
                moveTo(4.088f, 30.829f)
                lineToRelative(5.92f, -4.719f)
                lineToRelative(-2.335f, -7.186f)
                lineToRelative(-7.673f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF8000)),
                fillAlpha = 0.8f
            ) {
                moveTo(23.675f, 30.55f)
                lineToRelative(6.112f, -4.441f)
                lineToRelative(6.208f, 4.51f)
                lineToRelative(-9.949f, 7.228f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFF972E)),
                fillAlpha = 0.8f
            ) {
                moveTo(29.788f, 26.11f)
                lineToRelative(2.335f, -7.186f)
                lineToRelative(7.673f, 0f)
                lineToRelative(-3.8f, 11.696f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFAE5C)),
                fillAlpha = 0.8f
            ) {
                moveTo(32.123f, 18.924f)
                lineToRelative(-2.335f, -7.186f)
                lineToRelative(6.208f, -4.51f)
                lineToRelative(3.8f, 11.696f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBE7D)),
                fillAlpha = 0.8f
            ) {
                moveTo(29.788f, 11.738f)
                lineToRelative(-6.112f, -4.441f)
                lineToRelative(2.371f, -7.297f)
                lineToRelative(9.949f, 7.228f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD6AD)),
                fillAlpha = 0.8f
            ) {
                moveTo(16.12f, 7.297f)
                lineToRelative(-2.371f, -7.297f)
                lineToRelative(12.297f, 0f)
                lineToRelative(-2.371f, 7.297f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFAE5C)),
                fillAlpha = 0.8f
            ) {
                moveTo(7.673f, 18.924f)
                lineToRelative(2.335f, -7.186f)
                lineToRelative(-6.208f, -4.51f)
                lineToRelative(-3.8f, 11.696f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBE7D)),
                fillAlpha = 0.8f
            ) {
                moveTo(10.008f, 11.738f)
                lineToRelative(6.113f, -4.441f)
                lineToRelative(-2.371f, -7.297f)
                lineToRelative(-9.949f, 7.228f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.8f
            ) {
                moveTo(11.54f, 11.365f)
                lineToRelative(4.067f, 0.873f)
                lineToRelative(-4.067f, 0.873f)
                lineToRelative(-0.873f, 4.067f)
                lineToRelative(-0.873f, -4.067f)
                lineToRelative(-4.067f, -0.873f)
                lineToRelative(4.067f, -0.873f)
                lineToRelative(0.873f, -4.067f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.8f
            ) {
                moveTo(29.867f, 25.36f)
                lineToRelative(2.009f, 0.432f)
                lineToRelative(-2.009f, 0.431f)
                lineToRelative(-0.431f, 2.008f)
                lineToRelative(-0.431f, -2.008f)
                lineToRelative(-2.009f, -0.432f)
                lineToRelative(2.009f, -0.431f)
                lineToRelative(0.431f, -2.009f)
                close()
            }
        }.build()

        return _Topaz!!
    }

@Suppress("ObjectPropertyName")
private var _Topaz: ImageVector? = null
